export var HttpStatusCode;
(function (HttpStatusCode) {
    HttpStatusCode[HttpStatusCode["Ok"] = 200] = "Ok";
    HttpStatusCode[HttpStatusCode["NoContent"] = 204] = "NoContent";
    HttpStatusCode[HttpStatusCode["BadRequest"] = 400] = "BadRequest";
    HttpStatusCode[HttpStatusCode["Unauthorized"] = 401] = "Unauthorized";
    HttpStatusCode[HttpStatusCode["Forbidden"] = 403] = "Forbidden";
    HttpStatusCode[HttpStatusCode["NotFound"] = 404] = "NotFound";
    HttpStatusCode[HttpStatusCode["MethodNotAllowed"] = 405] = "MethodNotAllowed";
    HttpStatusCode[HttpStatusCode["RequestTimeout"] = 408] = "RequestTimeout";
    HttpStatusCode[HttpStatusCode["UnsupportedMediaType"] = 415] = "UnsupportedMediaType";
    HttpStatusCode[HttpStatusCode["InternalServerError"] = 500] = "InternalServerError";
    HttpStatusCode[HttpStatusCode["NotImplemented"] = 501] = "NotImplemented";
    HttpStatusCode[HttpStatusCode["BadGateway"] = 502] = "BadGateway";
    HttpStatusCode[HttpStatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    HttpStatusCode[HttpStatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
})(HttpStatusCode || (HttpStatusCode = {}));
// Mảng chứa mã lỗi và tên lỗi
export const httpErrCodeArray = [
    // 4xx: Client Errors
    { code: HttpStatusCode.BadRequest, name: '400 - Bad Request' },
    { code: HttpStatusCode.Unauthorized, name: '401 - Unauthorized' },
    { code: HttpStatusCode.Forbidden, name: '403 - Forbidden' },
    { code: HttpStatusCode.NotFound, name: '404 - Not Found' },
    { code: HttpStatusCode.MethodNotAllowed, name: '405 - Method Not Allowed' },
    { code: HttpStatusCode.RequestTimeout, name: '408 - Request Timeout' },
    {
        code: HttpStatusCode.UnsupportedMediaType,
        name: '415 - Unsupported Media Type'
    },
    // 5xx: Server Errors
    {
        code: HttpStatusCode.InternalServerError,
        name: '500 - Internal Server Error'
    },
    { code: HttpStatusCode.NotImplemented, name: '501 - Not Implemented' },
    { code: HttpStatusCode.BadGateway, name: '502 - Bad Gateway' },
    {
        code: HttpStatusCode.ServiceUnavailable,
        name: '503 - Service Unavailable'
    },
    { code: HttpStatusCode.GatewayTimeout, name: '504 - Gateway Timeout' }
];
// Helper functions
export const getHttpStatusCodeName = (code) => {
    const item = httpErrCodeArray.find((item) => item.code === code);
    return item ? item.name : 'Unknown Status Code';
};
